import { MENU_SCRAPING } from '../../constants'

const getMenuScrapingBreadcrumbItemByBrandId = brandId => ({
  path: `/tasks/menu-scraping?brandSearchTerm=${brandId}&menuIsAwaitingProbing=false`,
  type: MENU_SCRAPING,
  name: 'Menu Scraping',
})

export default getMenuScrapingBreadcrumbItemByBrandId
